import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
//import App from './App';
//import reportWebVitals from './reportWebVitals';
import Header from './compontents/Header'
import Footer from './compontents/Footer'

import Loading from './compontents/Loading'

import Login from "./pages/Login";

import Home from "./pages/Home";

import ProductDetail from "./pages/ProductDetail";


import Cart from "./pages/Cart";

import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";



import OrderResult from "./pages/OrderResult";




import { Provider } from "react-redux";
import { store } from "./model/store.js";


import "./i18n"

import { useTranslation } from "react-i18next";
import { t } from "react-i18next";



import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import ScrollToTop from './compontents/ScrollToTop';
import './firebase.js';


import MemberCenter from "./pages/MemberCenterPage/MemberCenter";
import UserInfo from "./pages/MemberCenterPage/UserInfo";
import UserGrade from "./pages/MemberCenterPage/UserGrade";
import Message from "./pages/MemberCenterPage/Message";
import UserCollar from "./pages/MemberCenterPage/UserCollar";
import Negotiation from "./pages/MemberCenterPage/Negotiation";
import NegotiationCreate from "./pages/MemberCenterPage/NegotiationCreate";
import NegotiationDetail from "./pages/MemberCenterPage/NegotiationDetail";
import NegotiationDispatch from "./pages/MemberCenterPage/NegotiationDispatch";
import NegotiationDispatchDetail from "./pages/MemberCenterPage/NegotiationDispatchDetail";
import OrderRecord from "./pages/MemberCenterPage/OrderRecord";
import OrderRecordDetail from "./pages/MemberCenterPage/OrderRecordDetail";
import Event from "./pages/MemberCenterPage/Event";
import EventCreate from "./pages/MemberCenterPage/EventCreate";
import EventDetail from "./pages/MemberCenterPage/EventDetail";
import ChangePw from "./pages/MemberCenterPage/ChangePw";


import Team from "./pages/MemberCenterPage/Team";





import ProductType from "./pages/ProductType";

const root = ReactDOM.createRoot(document.getElementById('root'));


root.render(
  <Provider store={store}>
    <BrowserRouter >
      <div className=' relative w-full h-full text-white bg-[#FDFCF9] ' >
        <div className="relative  flex flex-col">
          <ScrollToTop />
          <Loading />
          <Header />
          <div className='min-h-full grow '>
            <Routes>


              <Route path="/cart" element={<Cart />}></Route>


              <Route path="/aboutus" element={<AboutUs />}></Route>
              <Route path="/contactus" element={<ContactUs />}></Route>



              <Route path="/membercenter" >
                <Route path='' element={<Navigate to='userinfo' replace />} />
                <Route path="userinfo" element={<UserInfo />}></Route>
                <Route path="userGrade" element={<UserGrade />}></Route>
                <Route path="message" element={<Message />}></Route>
                <Route path="usercollar" element={<UserCollar />}></Route>
                <Route path="negotiation" element={<Negotiation />}></Route>
                <Route path="negotiation/:id" element={<NegotiationDetail />}></Route>
                <Route path="negotiationcreate" element={<NegotiationCreate />}></Route>
                <Route path="negotiationdispatch" element={<NegotiationDispatch />}></Route>
                <Route path="negotiationdispatch/:id" element={<NegotiationDispatchDetail />}></Route>
                <Route path="orderrecord" element={<OrderRecord />}></Route>
                <Route path="orderrecord/:id" element={<OrderRecordDetail />}></Route>

                <Route path="event" element={<Event />}></Route>
                <Route path="eventcreate" element={<EventCreate />}></Route>
                <Route path="event/:id" element={<EventDetail />}></Route>
                {/* <Route path="recommend" element={<Recommend />}></Route> */}
                <Route path="changepw" element={<ChangePw />}></Route>
                <Route path="team" element={<Team />}></Route>
                <Route path='*' element={<Navigate to='userinfo' replace />} />
              </Route>



              <Route path="/login" element={<Login />}></Route>
              {/* <Route path="/register" element={<Register />}></Route> */}

            

              <Route path="/orderresult" element={<OrderResult />}></Route>



              <Route path="/" element={<Home />}></Route>
              <Route path="/producttype" element={<ProductType />}></Route>
              <Route path="/product/:id" element={<ProductDetail />}></Route>

              <Route path='*' element={<Navigate to='/' replace />} />

            </Routes>

          </div>


          {
            <Footer />
          }


        </div>
      </div>

    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
